"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectContentLoop = exports.isContentLoopSelected = void 0;
var slate_1 = require("slate");
var getContentLoopDummyPoint = function (contentLoopPath) {
    return {
        path: __spreadArray(__spreadArray([], __read(contentLoopPath), false), [0, 0], false),
        offset: 0,
    };
};
var isContentLoopSelected = function (editor, contentLoopPath) {
    if (!editor.selection) {
        return false;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var endPoint = slate_1.Range.end(editor.selection);
    var dummyPoint = getContentLoopDummyPoint(contentLoopPath);
    var isExactlySelected = slate_1.Range.isCollapsed(editor.selection) && slate_1.Point.equals(startPoint, dummyPoint);
    var isPartiallySelected = (slate_1.Path.isBefore(startPoint.path, contentLoopPath) && slate_1.Path.isAncestor(contentLoopPath, endPoint.path)) ||
        (slate_1.Path.isAncestor(contentLoopPath, startPoint.path) && slate_1.Path.isAfter(endPoint.path, contentLoopPath));
    var isFullySelected = slate_1.Path.isBefore(startPoint.path, contentLoopPath) && slate_1.Path.isAfter(endPoint.path, contentLoopPath);
    return isExactlySelected || isPartiallySelected || isFullySelected;
};
exports.isContentLoopSelected = isContentLoopSelected;
var selectContentLoop = function (editor, contentLoopPath) {
    var dummyPoint = getContentLoopDummyPoint(contentLoopPath);
    slate_1.Transforms.select(editor, dummyPoint);
};
exports.selectContentLoop = selectContentLoop;
